<template>
    <div class="">
        <slot name="beforeform" :videoId="videoId" :selectVideo="selectVideo"></slot>

        <form-ajax
                v-bind="getInputProps({
                    notReload: true,
                    disableNotify: true,
                    disablePageLoading: true,
                    isChildForm: false,
                    disableForm: !!+disableFormWhenDisableUpload && disableUpload
                })"

                ref="formAjax"
        >
            <template #default="{ getError, isError, msg }">
                <component
                        :is="formTag"
                        :action="url"
                        :method="method"
                        @submit.prevent="submit"

                        ref="form"
                >
                    <input type="hidden" name="videoName" :value="videoName">
                    <input type="hidden" name="videoSize" :value="videoSize">

                    <slot name="hidden" :getError="getError" :isError="isError" :msg="msg" :videoId="videoId" :setVideoId="setVideoId"></slot>

                    <slot name="before" :getError="getError" :isError="isError" :msg="msg" :videoId="videoId" :setVideoId="setVideoId"></slot>

                    <div class="row">
                        <div class="col-lg-8 px-md-0 position-relative border-md-right border-gray-lighten">
                            <slot name="beforevideo" :getError="getError" :isError="isError" :msg="msg" :setVideoId="setVideoId"></slot>
                            <slot name="player">
                                <div class="px-lg-7 py-3 pr-lg-3 border-bottom border-gray-lighten">
                                    <template v-if="!+disableRecord">
                                        <register-video
                                                :upload-link="uploadLink"
                                                :default-upload-error="defaultUploadError"
                                                :icon="registerIcon"
                                                :label="registerLabel"
                                                :icon-start-recording="iconStartRecording"
                                                :label-start-recording="labelStartRecording"
                                                :icon-record-again="iconRecordAgain"
                                                :label-record-again="labelRecordAgain"
                                                :label-countdown-recording="labelCountdownRecording"
                                                :label-play-video="labelPlayVideo"

                                                :default-device-error="defaultDeviceError"
                                                :default-error="defaultPlayerError"

                                                :disable-stored-video="true"

                                                ref="player"
                                        >
                                            <template #after="{}">
                                                <div></div>
                                            </template>
                                            <template #upload="{showOnlineRecords}">
                                                <div class="px-3" v-if="showOnlineRecords">or</div>
                                                <input-file
                                                        class=""
                                                        :disable-file-to-send="1"
                                                        class-name="position-relative"
                                                        ref="file"
                                                >
                                                    <template #content="{error, label}">
                                                        <div
                                                                class="pt-8 pl-8 bg-contain"
                                                                :style="'background-image: url('+inputFileIcon+')'"
                                                        ></div>
                                                        <div class="text-gray-dark text-center pt-3">
                                                            {{ inputFileLabel }}
                                                        </div>
                                                        <template v-if="error">
                                                            <div class="text-danger text-center pt-3">
                                                                {{ error }}
                                                            </div>
                                                        </template>
                                                    </template>
                                                </input-file>
                                            </template>
                                        </register-video>
                                    </template>
                                </div>
                            </slot>

                            <slot name="aftervideo" :getError="getError" :isError="isError" :msg="msg" :setVideoId="setVideoId"></slot>
                        </div>
                        <div class="align-items-start col d-flex flex-column px-0">

                            <slot name="beforerightcolumn" :getError="getError" :isError="isError" :msg="msg" :setVideoId="setVideoId"></slot>
                            <div class="w-100 mt-auto"></div>
                            <slot name="afterrightcolumn" :getError="getError" :isError="isError" :msg="msg" :setVideoId="setVideoId"></slot>

                        </div>
                    </div>

                    <slot name="after" :videoId="videoId" :setVideoId="setVideoId"></slot>

                    <div class="row">
                        <div class="col-lg-8 border-right border-gray-lighten py-3">
                            <slot name="leftsubmit" :getError="getError" :isError="isError" :msg="msg" :videoId="videoId" :setVideoId="setVideoId"></slot>
                        </div>
                        <div class="col-lg py-lg-3">
                            <slot name="submit" :getError="getError" :isError="isError" :msg="msg" :isLoading="isLoading" :submitLabel="submitLabel" :videoId="videoId" :closeModal="closeModal" setVideoId="setVideoId">
                                <button
                                        type="submit"
                                        class="btn btn-lg btn-primary w-100"
                                        :disabled="isLoading"
                                >
                                    {{ submitLabel }}
                                </button>
                            </slot>
                        </div>
                    </div>
                </component>
            </template>
        </form-ajax>

        <slot name="afterform" :videoId="videoId" :setVideoId="setVideoId"></slot>
    </div>

</template>

<script>
    import mixinCommon from '../mixinCommon';
    import mixinPubSub from '../mixinPubSub';

    import FormAjax from '../FormAjax';
    import RegisterVideo from '../RegisterVideo';
    import InputFile from '../InputFile'

    export default {
        mixins: [mixinCommon, mixinPubSub],
        components: {
            'form-ajax': FormAjax,
            'register-video': RegisterVideo,
            'input-file': InputFile
        },
        props: {
            ...FormAjax.props,

            formTag: {
                type: String,
                default: 'form'
            },

            url: {
                type: String,
                default: '#'
            },
            method: {
                type: String,
                default: 'post'
            },
            defaultVideoName: {
                type: String,
                default: 'video'
            },

            inputFileIcon: {
                type: String,
                default: ''
            },
            inputFileLabel: {
                type: String,
                default: ''
            },
            registerIcon: {
                type: String,
                default: ''
            },
            registerLabel: {
                type: String,
                default: ''
            },

            inputClassName: {
                type: String,
                default: 'h-100 min-height--4-line position-relative py-4'
            },

            disableInputFile: {
                type: [String, Number, Boolean],
                default: false
            },
            disableRecord: {
                type: [String, Number, Boolean],
                default: false
            },

            disableFormWhenDisableUpload: {
                type: [String, Number, Boolean],
                default: false
            },

            submitLabel: {
                type: String,
                default: 'upload'
            },

            defaultUploadError: {
                type: String,
                default: 'Error uploading video'
            },
            startingUpload: {
                type: String,
                default: 'Uploading video...'
            },

            defaultDeviceError: {
                type: String,
                default: 'Error to webcam connection.'
            },

            defaultPlayerError: {
                type: String,
                default: ''
            },

            startSaveMessage: {
                type: String,
                default: 'Processing data...'
            },

            defaultErrorVideoNotUploaded: {
                type: String,
                default: ''
            },

            iconRecordAgain: {
                type: String,
                default: ''
            },
            labelRecordAgain: {
                type: String,
                default: ''
            },

            iconStartRecording: {
                type: String,
                default: ''
            },
            labelStartRecording: {
                type: String,
                default: ''
            },
            labelCountdownRecording: {
                type: String,
                default: ''
            },
            labelPlayVideo: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                storedBlob: null,
                videoBlob: null,

                // saving data
                videoName: this.defaultVideoName,
                videoSize: 0,
                response: null,
                videoData: null,
                error: '',

                // uploading
                uploadLink: '',
                uploadProgress: 0,
                uploadError: '',
                isUploaded: false,

                selectedVideoId: null,

                reloadDelay: 0,

                // child components
                registerVideo: null,
                inputFile: null,

                playerFormatError: '',

                isLoading: false
            }
        },
        computed: {
            disableUpload() {
                return !!+this.disableRecord || this.isUploaded || this.selectedVideoId;
            },
            videoId() {
                return this.selectedVideoId || (this.videoData ? this.videoData.id || null : null);
            },
        },
        watch: {
            response: {
                handler(resp) {

                    if (!resp.status || !resp.data || !resp.data.uploadLink || !resp.data.video) {
                        return;
                    }
                    const {uploadLink, video} = resp.data;
                    this.uploadLink = uploadLink;
                    this.videoData = video;
                }
            },
            uploadProgress(progress) {
                if (this.isLoading) {
                    this.setLoading(parseInt(+progress * 100) + ' %');
                }
            }
        },
        mounted() {
            this.registerVideo = this.getChildByName('RegisterVideo');
            this.inputFile = this.$refs.file;
            const formAjax = this.$refs.formAjax;

            formAjax.$watch('response', (response) => this.response = response);
            formAjax.$watch('reloadDelay', (reloadDelay) => this.reloadDelay = reloadDelay);
            if (!this.disableRecord) {
                this.inputFile.$watch('blob', (blob) => this.setVideoFile(blob));
            }

            if (this.registerVideo) {
                this.registerVideo.$watch('storedBlob', (storedBlob) => this.storedBlob = storedBlob);
                this.registerVideo.$watch('videoBlob', (videoBlob) => this.videoBlob = videoBlob);
                this.registerVideo.$watch('videoSize', (videoSize) => this.videoSize = videoSize);

                this.registerVideo.$watch('uploadProgress', (uploadProgress) => this.uploadProgress = +uploadProgress);
                this.registerVideo.$watch('isUploaded', (isUploaded) => this.isUploaded = isUploaded);

                this.registerVideo.$watch('error', (uploadError) => this.uploadError = uploadError);

                this.registerVideo.$watch('playerError', (playerFormatError) => this.playerFormatError = playerFormatError);
            }
        },
        methods: {
            submit(evt) {

                if (evt && typeof evt.preventDefault === 'function') {
                    evt.preventDefault();
                }

                this.setLoading(this.startSaveMessage);

                if (this.playerFormatError) {
                    setTimeout(() => {
                        this.setLoading(this.defaultPlayerError);

                        setTimeout(() => {
                            this.hideLoading();

                            this.notifyBy('error', {message: this.defaultPlayerError});
                        }, 2000);
                    }, 1000);
                } else {
                    if (!this.selectedVideoId && this.registerVideo && !this.registerVideo.checkBlobIsAlreadyToUpload()) {
                        this.setLoading(this.defaultErrorVideoNotUploaded);

                        setTimeout(() => {
                            this.hideLoading();
                            this.notifyBy('error', {message: this.defaultErrorVideoNotUploaded});
                        }, 2000);
                        return;
                    }
                    const formAjax = this.$refs.formAjax;
                    formAjax.$once('response', async (resp) => {
                        const {status, data, msg, redirectTo} = resp;
                        if (status) {
                            this.error = '';

                            let uploadStatus = false;
                            if (this.disableUpload) {
                                uploadStatus = true;
                            } else {
                                this.setLoading(this.startingUpload);
                                //this.notifyBy('success', { message: msg || this.startingUpload });
                                const {uploadLink = this.uploadLink} = data;

                                // uploading video
                                uploadStatus = await this.registerVideo.startUploadVideo(uploadLink);
                            }

                            if (uploadStatus) {
                                this.setLoading(msg);

                                this.$emit('response', {...resp, status: true});

                                if (this.notReload) {
                                    setTimeout(() => {
                                        this.hideLoading();
                                        this.notifyBy('success', {message: msg});
                                    }, 2000);
                                } else {
                                    if (redirectTo) {
                                        setTimeout(() => {
                                            document.location.href = redirectTo;
                                        }, this.reloadDelay);
                                    } else {
                                        setTimeout(() => {
                                            document.location.reload();
                                        }, this.reloadDelay);
                                    }
                                }
                            } else {
                                this.error = this.uploadError;

                                this.setLoading(this.error);

                                this.$emit('response', {...resp, status: false});

                                setTimeout(() => {
                                    this.hideLoading();

                                    this.notifyBy('error', {message: this.error});
                                }, 2000);
                            }
                        } else {
                            this.error = msg;

                            this.setLoading(this.error);

                            this.$emit('response', {...resp, status: false});

                            setTimeout(() => {
                                this.hideLoading();

                                this.notifyBy('error', {message: this.error});
                            }, 2000);
                        }
                    });
                    formAjax.submit();
                }
            },

            async setVideoFile(videoBlob) {
                this.registerVideo.removePlayer();
                this.registerVideo.loadPlayer(videoBlob);
                this.registerVideo.setVideoBlob(videoBlob);
            },
            selectVideo(videoData) {
                this.videoData = videoData;
            },

            setVideoId(videoId) {
                this.selectedVideoId = videoId;
            },

            setLoading(message) {
                this.isLoading = true;
                this.triggerPageLoading(this.isLoading, message);
            },
            hideLoading() {
                this.isLoading = false;
                this.triggerPageLoading(this.isLoading, '');
            },

            getInputProps(overrideProps = {}) {
                return this.getComponentProps(FormAjax, overrideProps);
            },
            closeModal() {
                if (this.registerVideo) {

                    this.registerVideo.resetRecorder();
                }
            }

        }
    }
</script>
